import { useMutation } from "react-query";
import { updateWarrantyCoverage } from "../../../../../actions/Utilities/WarrantyCoverage";
import { toast } from "components/toastNotification";
import { IWarrantyCoverage } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateWarrantyCoverage,
  warrantyCoverageReFetching,
} from "../atoms/atoms";

const useEditWarrantyCoverage = () => {
  const setActionEditState = useSetRecoilState(editStateWarrantyCoverage);
  const [isReFetching, setIsReFetching] = useRecoilState(
    warrantyCoverageReFetching
  );

  const { mutate } = useMutation(
    (newData: IWarrantyCoverage) => updateWarrantyCoverage(newData),
    {
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire(
            "Updating Warranty Coverage failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Warranty Coverage Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Warranty Coverage Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Warranty Coverage failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Warranty Coverage failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Warranty Coverage failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire(
                "Updating Warranty Coverage failed",
                `${res}`,
                "error"
              );
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Warranty Coverage failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditWarrantyCoverage;
